import React, { ReactElement } from 'react';
import { RepliconMenuVisibleList } from './RepliconMenuVisibleList';
import { RepliconProductBar } from './RepliconProductBar';

export const RepliconMenuContent = (props: {
  handleDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  navigationMetadata: any;
  handleSettingsPopUp: React.Dispatch<React.SetStateAction<boolean>>;
  isDocked: boolean;
}): ReactElement => {
  return (
    <>
      <RepliconProductBar
        handleDrawerOpen={props.handleDrawerOpen}
        navigationMetadata={props.navigationMetadata}
      ></RepliconProductBar>
      <RepliconMenuVisibleList
        navigationMetadata={props.navigationMetadata}
        handleSettingsPopUp={props.handleSettingsPopUp}
        isDocked={props.isDocked}
      ></RepliconMenuVisibleList>
    </>
  );
};
